exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.stepElementBox___24d2D {\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  justify-content: space-around;\n  min-height: 500px;\n}\n.stepElementBox___24d2D .zola-ui.banner {\n  padding: 12px;\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"stepElementBox": "stepElementBox___24d2D"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/SingleSample/SingleSampleFlow/styles.module.less
// module id = 1766
// module chunks = 68